﻿import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
import { Utility } from '../Utility.js';
export { SearchEntityTool };

/**
 * Class SearchEntityTool
 */
const SearchEntityTool = function () {

    // Define this
    var mySearchEntityTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // Already initialize
    this._toolInitialize = false;

    // Entity Adress info
    this._entityAddressInfo = {};

    // Style Search highligh
    this._SearchHighlighStyles = function (feature)
    {
        var imgIconEntity = ""
        switch(feature.getProperties()[mySearchEntityTool._entityAddressInfo.column.entity])
        {
            case "GP_Imoveis_Habitacao":
                imgIconEntity = "bcp/imovel_habitacao3.svg";
                break;
            case "GP_Imoveis_Escritorios":
                imgIconEntity = "bcp/imovel_escritorio3.svg";
                break;
            case "GP_Imoveis_Hoteis":
                imgIconEntity = "bcp/imovel_hotel3.svg";
                break;
            default:
                // do nothing
        }

        return [
            new Style({
                 image: new CircleStyle({
                     radius: 15,
                     stroke: new Stroke({
                         color: 'rgba(255,255,0,0.6)',
                         width: 5
                     }),
                     fill: new Fill({
                         color: 'rgba(0, 0, 255, 0.2)'
                     })
                 }),
                 stroke: new Stroke({
                     color: 'rgba(255,255,0,0.6)',
                     width: 7
                 }),
                 fill: new Fill({
                     color: 'rgba(0, 0, 255, 0.2)'
                 })
            }),
            new Style({
                image: new Icon({
                    src: location.origin + '/images/' + imgIconEntity,
                    scale: 0.08
                })
            })
        ];
    };

    // Style Search highligh
    //this._SearchHighlighStyles = [
    //        new Style({
    //            image: new CircleStyle({
    //                radius: 10,
    //                stroke: new Stroke({
    //                    color: 'rgba(255,255,0,0.6)',
    //                    width: 5
    //                }),
    //                fill: new Fill({
    //                    color: 'rgba(0, 0, 255, 0.2)'
    //                })
    //            }),
    //            stroke: new Stroke({
    //                color: 'rgba(255,255,0,0.6)',
    //                width: 7
    //            }),
    //            fill: new Fill({
    //                color: 'rgba(0, 0, 255, 0.2)'
    //            })
    //        })
    //];


    // -- end private variable --------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Build search entity address interface
     */
    this.BuildSearchAddressInterface = function (mapSgs)
    {
        // -- Select local ------------------------------------------------------------------------
        const searchEntityLocalZone = document.createElement('div');
        searchEntityLocalZone.id = "id-search-entity-address-local-zone";
        searchEntityLocalZone.className = "col col-md-6 local";
        searchEntityLocalZone.setAttribute("style", "display: none;");

        // Select 2 for local
        const searchEntityAddressLocalSelect = document.createElement('select');
        searchEntityAddressLocalSelect.id = "id-search-entity-address-local";
        searchEntityAddressLocalSelect.className = "form-control";
        searchEntityAddressLocalSelect.setAttribute("style", "display: none;");
        searchEntityLocalZone.appendChild(searchEntityAddressLocalSelect);
        const searchEntityAddressLocalSelectOption = document.createElement('option');
        searchEntityAddressLocalSelect.appendChild(searchEntityAddressLocalSelectOption);

        // -- Input index -------------------------------------------------------------------------
        const searchEntityAddressZone = document.createElement('div');
        searchEntityAddressZone.id = "id-search-entity-address-zone";

        // Input address
        var placeHolder = mySearchEntityTool._utility.GetPropertyInfoInConfigArray(mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "INPUT_ADDRESS", "PLACEHOLDER").value;
        const searchEntityAddressInput = document.createElement('input');
        searchEntityAddressInput.id = "id-search-entity-address";
        searchEntityAddressInput.className = "form-control address";
        searchEntityAddressInput.setAttribute("type", "text");
        searchEntityAddressInput.setAttribute("placeholder", placeHolder);
        searchEntityAddressZone.appendChild(searchEntityAddressInput);

        // Keypress address input
        const handleKeypressInput = function (event)
        {
            var address = $("#id-search-entity-address").val();

            if (event.keyCode == 13) {
                event.preventDefault();
                return false;
            }
            if (address.length >= 3) {
                mySearchEntityTool._CreateSearchEntityAddress('id-search-entity-address');
            }
        }
        searchEntityAddressInput.addEventListener('keypress', handleKeypressInput, false);

        // Input spin
        const searchEntityAddressSpin = document.createElement('i');
        searchEntityAddressSpin.id = 'id-search-entity-address-spin'
        searchEntityAddressSpin.className = "fa fa-spinner fa-spin search-toponymy-spin";
        searchEntityAddressSpin.setAttribute("style", "display: none;");
        searchEntityAddressZone.appendChild(searchEntityAddressSpin);

        // Input id selected
        const searchEntityAddressIdInput = document.createElement('input');
        searchEntityAddressIdInput.id = "id-search-entity-address-id";
        searchEntityAddressIdInput.setAttribute("type", "hidden");
        searchEntityAddressZone.appendChild(searchEntityAddressIdInput);

        // -- Menu panel road builder tool --------------------------------------------------------
        const searchEntityAddressTool = document.createElement('div');
        searchEntityAddressTool.appendChild(searchEntityLocalZone);
        searchEntityAddressTool.appendChild(searchEntityAddressZone);

        return searchEntityAddressTool;
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------
    
    /**
     * Create search entity address
     * @param {string} node, input node with search entity address
     */
    this._CreateSearchEntityAddress = function(node)
    {
        var SearchAutocomplete = $("#" + node).autocomplete({
            source: (mySearchEntityTool._entityAddressInfo.direct_from_table)?mySearchEntityTool._SearchResultDirectFromTable:mySearchEntityTool._SearchResult,
            minLength: 3,
            select: mySearchEntityTool._SearchSelected,
        }).autocomplete("instance")._renderItem = mySearchEntityTool._SearchRenderItem;
    }

    /**
     * Render funtion for autocomplete toponymy
     * @param {any} ul jQueryUI object
     * @param {any} item jQueryUI object
     */
    this._SearchRenderItem = function (ul, item)
    {
        var searchContentSelected = item.label; // + ", " + item.type;
        var title = "";
        //if (item.type == "")
        //    searchContentSelected = item.label;
        if (item.concelho != null && item.concelho != "") {
            //searchContentSelected += ", " + item.concelho;
            title = "Concelho: " + item.concelho;
        }
        if (item.freguesia != null && item.freguesia != "") {
            //searchContentSelected += ", " + item.freguesia;
            title += ((title === "")? "": ", ") + "Freguesia: " + item.freguesia;
        }

        return $("<li class='search-result-li' >")
            .append("<div class='search-result-place' title='" + title + "'><i class='fa fa-map-marker' aria-hidden='true'></i> " + searchContentSelected + "</div>")
            .appendTo(ul);
    }

    /**
     * Search result for autocomplete
     * @param {object} request jQueryUI object
     * @param {object} response jQueryUI object
     * @param {string} url
     */
    this._SearchResult = function (request, response, url) {
        // Wait for it
        $('#id-search-entity-address-spin').show();

        // Get msg not found
        var msgNotFound = mySearchEntityTool._utility.GetPropertyInfoInConfigArray(mySearchEntityTool._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "INPUT_ADDRESS", "NO_RESULT").value;

        //var freguesiaVal = $('#id-toponymy-search-select-freguesia option:selected').text();

        // Get request with no accent
        var requestUpper = mySearchEntityTool._utility.RemoveAccents(request.term.toUpperCase());

        //var layerInfo = mySearchEntityTool._mapSgs.layerTree.FindLayerInfoOnListLayer(mySearchEntityTool._entityAddressInfo.layer_name);
        var getFeatureUrl = mySearchEntityTool._entityAddressInfo.geoserver + "/wfs";

        // Build query
        var cqlFilter = mySearchEntityTool._entityAddressInfo.column.address_norm + " like '%" + requestUpper + "%'";
        var localText = "";
        if(mySearchEntityTool._entityLocalInfo.exists)
        {
            var valueLocalSelect = $('#id-search-entity-address-local').select2('data')[0].id;
            if(valueLocalSelect !== "")
            {
                localText = $('#id-search-entity-address-local').select2('data')[0].text;
                cqlFilter += " AND  " + mySearchEntityTool._entityAddressInfo.column.local_norm + " = '" + valueLocalSelect + "'";
            }
        }
        //if(freguesiaVal !== null && freguesiaVal !== "") {
        //    cqlFilter += " AND  " + mySearch._layernamePropertyFreguesia + " like '%" + freguesiaVal + "%'";
        //}

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": mySearchEntityTool._entityAddressInfo.workspace + ':' + mySearchEntityTool._entityAddressInfo.layer_name,
                "cql_filter": cqlFilter,
                'srsName': mySearchEntityTool._mapSgs._settings.projection.code_,
                "outputFormat": 'application/json'
            }
        });

        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    response(($.map(data.features, function (feature, i) {
                        var addressResult = (feature.properties[mySearchEntityTool._entityAddressInfo.column.address])?feature.properties[mySearchEntityTool._entityAddressInfo.column.address]:"";
                        var concelhoResult = (feature.properties[mySearchEntityTool._entityAddressInfo.column.concelho])?feature.properties[mySearchEntityTool._entityAddressInfo.column.concelho]:"";
                        var freguesiaResult = (feature.properties[mySearchEntityTool._entityAddressInfo.column.freguesia])?feature.properties[mySearchEntityTool._entityAddressInfo.column.freguesia]:"";
                        var localResult = (localText !== "")?localText:(feature.properties[mySearchEntityTool._entityAddressInfo.column.local])?feature.properties[mySearchEntityTool._entityAddressInfo.column.local]:"";
                        var cpResult = (feature.properties[mySearchEntityTool._entityAddressInfo.column.cp])?feature.properties[mySearchEntityTool._entityAddressInfo.column.cp]:"";
                        var arrayId = feature.id.split(".");
                        var idEntity = (arrayId.length == 0)?arrayId[0]:arrayId[1];

                        return {
                            "searchOption": "toponymy",
                            "label":  addressResult + ((cpResult !== "")?" "+cpResult:"") + ((localResult !== "")?" "+localResult:"") + ((freguesiaResult!=="")?", "+freguesiaResult:"") + ((concelhoResult !== "")?", "+concelhoResult:""),
                            "type": "",
                            "id_entity": idEntity,
                            "value": feature,
                            "cp": cpResult,
                            "local": localResult,
                            "freguesia": (feature.properties[mySearchEntityTool._entityAddressInfo.column.freguesia])?feature.properties[mySearchEntityTool._entityAddressInfo.column.freguesia]:"",
                            "concelho": (feature.properties[mySearchEntityTool._entityAddressInfo.column.concelho])?feature.properties[mySearchEntityTool._entityAddressInfo.column.concelho]:"",
                            "distrito": (feature.properties[mySearchEntityTool._entityAddressInfo.column.distrito])?feature.properties[mySearchEntityTool._entityAddressInfo.column.distrito]:""
                        }
                    })).slice(0, 10));
                }
                else {
                    toastr["warning"](msgNotFound);
                }
            }
            else {
                toastr["warning"](msgNotFound);
            }
        });

        getFeature.always(function() {
            // Stop waiting
            $('#id-search-entity-address-spin').hide();
        });
    }

    /**
     * Search result for autocomplete direct in table
     * @param {object} request jQueryUI object
     * @param {object} response jQueryUI object
     * @param {string} url
     */
    this._SearchResultDirectFromTable = function (request, response, url) {
        // Wait for it
        $('#id-search-entity-address-spin').show();

        // Get msg not found
        var msgNotFound = mySearchEntityTool._utility.GetPropertyInfoInConfigArray(mySearchEntityTool._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "INPUT_ADDRESS", "NO_RESULT").value;

        // Get request with no accent
        var requestUpper = mySearchEntityTool._utility.RemoveAccents(request.term.toUpperCase());

        // Local
        var local = "";
        var localText = "";
        if(mySearchEntityTool._entityLocalInfo.exists)
        {
            local = $('#id-search-entity-address-local').select2('data')[0].id;
            if(local !== "")
            {
                localText = $('#id-search-entity-address-local').select2('data')[0].text;
            }
        }

        var urlFunction = null;
        if(mySearchEntityTool._mapSgs._settings.getVisibleOperations().AvimTool)
            urlFunction = "AvimTool/GetEntityAddressMatch";
        if(urlFunction !== null)
        {

            $.ajax({
                type: 'GET',
                url:'/rest/app/' + urlFunction + '?local=' + local + '&address=' + requestUpper,
                async: true,
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro na obtenção das moradas");
                    }
                    else
                    {
                        if(data.result !== null && data.result.length > 0)
                        {
                            response(($.map(data.result, function (objAddress, i)
                            {
                                var addressResult = (objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.address])?objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.address]:"";
                                var concelhoResult = (objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.concelho])?objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.concelho]:"";
                                var freguesiaResult = (objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.freguesia])?objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.freguesia]:"";
                                var localResult = (localText !== "")?localText:(objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.local])?objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.local]:"";
                                var cpResult = (objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.cp])?objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.cp]:"";
                                var idEntity = objAddress.id;

                                return {
                                    "searchOption": "toponymy",
                                    "label":  addressResult + ((cpResult !== "")?" "+cpResult:"") + ((localResult !== "")?" "+localResult:"") + ((freguesiaResult!=="")?", "+freguesiaResult:"") + ((concelhoResult !== "")?", "+concelhoResult:""),
                                    "type": "",
                                    "id_entity": idEntity,
                                    "value": null,
                                    "cp": cpResult,
                                    "local": localResult,
                                    "freguesia": (objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.freguesia])?objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.freguesia]:"",
                                    "concelho": (objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.concelho])?objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.concelho]:"",
                                    "distrito": (objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.distrito])?objAddress[mySearchEntityTool._entityAddressInfo.column_ajax.distrito]:""
                                }
                            })).slice(0, 10));
                        }
                        else
                            toastr["warning"](msgNotFound);
                    }
                    // Stop waiting
                    $('#id-search-entity-address-spin').hide();
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro na obtenção das moradas");
                    // Stop waiting
                    $('#id-search-entity-address-spin').hide();
                }
            });
        }
    }

    /**
     * Go to Search selected
     * @param {any} event jQueryUI object
     * @param {any} ui jQueryUI object
     */
    this._SearchSelected = function (event, ui) {
        event.preventDefault();
        var geoserverUrl = mySearchEntityTool._entityAddressInfo.geoserver;

        // Id entity
        var idEntity = ui.item.id_entity;

        if(idEntity) {
            mySearchEntityTool._mapSgs.SetFeaturesHighlightByArray2(mySearchEntityTool._entityAddressInfo.workspace, mySearchEntityTool._entityAddressInfo.layer_name, mySearchEntityTool._entityAddressInfo.geoserver, true, [idEntity], mySearchEntityTool._SearchHighlighStyles, mySearchEntityTool._entityAddressInfo.column.geom + "," + mySearchEntityTool._entityAddressInfo.column.entity, true, true);
        }

        $('#id-search-entity-address').val(ui.item.label);
        $('#id-search-entity-address-id').val(idEntity);
    }

    // -- end private method ----------------------------------------------------------------------
}

/**
 * Init search entity tool
 * @param {object} mapSgs, map object
 */
SearchEntityTool.prototype.Init = function (mapSgs) {
    if (!this._toolInitialize) {
        this._toolInitialize = true;

        // Set map info
        this._mapSgs = mapSgs;

        // This object 
        var objSearchEntityTool = this;

        // Get entity local info
        var existsLocal = this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "INPUT_LOCAL", "EXISTS");
        var placeholderLocal = this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "INPUT_LOCAL", "PLACEHOLDER");
        this._entityLocalInfo = {
            exists: (existsLocal !== undefined)?eval(existsLocal.value):false,
            placeholder: (placeholderLocal !== undefined)?placeholderLocal.value:""
        };

        // Get entity address info
        var directFromTable = this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "EXECUTION", "DIRECT_FROM_TABLE");
        this._entityAddressInfo = {
            direct_from_table: (directFromTable !== undefined)?eval(directFromTable.value):false,
            geoserver: this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "LAYER_INFO", "GEOSERVER").value,
            workspace: this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "LAYER_INFO", "WORKSPACE").value,
            layer_name: this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "LAYER_INFO", "LAYER_NAME").value,
            column: {
                id: this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "LAYER_INFO", "COLUMN_ID").value,
                entity: this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "LAYER_INFO", "COLUMN_ENTITY").value,
                address_norm: this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "LAYER_INFO", "COLUMN_ADDRESS_NORM").value,
                address: this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "LAYER_INFO", "COLUMN_ADDRESS").value,
                cp: this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "LAYER_INFO", "COLUMN_CP").value,
                local: this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "LAYER_INFO", "COLUMN_LOCAL").value,
                local_norm: this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "LAYER_INFO", "COLUMN_LOCAL_NORM").value,
                freguesia: this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "LAYER_INFO", "COLUMN_FREGUESIA").value,
                concelho: this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "LAYER_INFO", "COLUMN_CONCELHO").value,
                distrito: this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "LAYER_INFO", "COLUMN_DISTRITO").value,
                geom: this._mapSgs._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ENTITY_ADDRESS", "LAYER_INFO", "COLUMN_GEOM").value
            },
            column_ajax: {}
        };
        // If direct from table then lower first char of the column to column_ajax, because ajax result from direct from table alway put de first caracter in lowercase
        if(this._entityAddressInfo.direct_from_table)
        {
            for(var i = 0; i < Object.keys(this._entityAddressInfo.column).length; i++)
            {
                var key = Object.keys(this._entityAddressInfo.column)[i];
                this._entityAddressInfo.column_ajax[key] = this._mapSgs._utility.LowerFirstString(this._entityAddressInfo.column[key]);
            }
        }

        // Inicialize select2 for local
        if(this._entityLocalInfo.exists)
        {
            // Set html local
            $('#id-search-entity-address-local')[0].setAttribute("title", this._entityLocalInfo.placeholder);
            $('#id-search-entity-address-zone')[0].className = "col col-md-6 address";
            $('#id-search-entity-address-local-zone').show();

            // Set select2 local find
            var urlFunction = null;
            if(this._mapSgs._settings.getVisibleOperations().AvimTool)
                urlFunction = "AvimTool/GetLocalMatchForSelect2";
            if(urlFunction !== null)
            {
                $('#id-search-entity-address-local').select2(
                {
                    ajax:
                    {
                        type: 'GET',
                        url: '/rest/app/' + urlFunction,
                        dataType: 'json',
                        delay: 250,
                        data: function (term) {
                            return term;
                        },
                        processResults: function (data, params) {
                            var listLocal = data.result;
                            if (listLocal === null)
                            {
                                return {
                                    "results": [],
                                    "pagination": {
                                        "more": false
                                    }
                                };
                            }

                            var resultArray = [];
                            for (var i = 0; i < listLocal.length; i++) {
                                var localObj = listLocal[i];
                                resultArray.push({
                                    "text": localObj.text,
                                    "id": localObj.id
                                });
                            }

                            return {
                                "results": resultArray,
                                "pagination": {
                                    "more": false
                                }
                            }
                        },
                        cache: true
                    },
                    minimumInputLength: 2,
                    language: "pt",
                    width: '230px',
                    dropdownParent: $('#id-search-entity-address-local-zone')
                });

                // On select local clean address
                $('#id-search-entity-address-local').on('select2:select', function (e) {
                   $('#id-search-entity-address').val("");
                });
            }
            else
            {
                $('#id-search-entity-address-local-zone').hide();
            }
        }
    }
};